export const BUTTON_STYLE_PRESETS = [
    {
        id: 'solid-brand',
        name: 'Solid Brand Fill',
        desc: 'Solid primary button with clean muted details button',
        settings: {
            btnBorder: 'none',
            btnColor: '#3b82f6',
            btnTextColor: '#ffffff',
            btnShadow: '0 2px 6px rgba(59,130,246,0.2)',
            btnRadius: '6px',
            btnHoverBg: '#2563eb',
            btnHoverColor: '#ffffff',
            btnHoverBorder: '',
            detailBtnBg: '#f8fafc',
            detailBtnColor: '#475569',
            detailBtnBorder: '1px solid #cbd5e1',
            detailBtnShadow: 'none'
        }
    },
    {
        id: 'modern-outline',
        name: 'Modern Outline / Ghost',
        desc: 'Sleek outlined buttons with solid fill on hover',
        settings: {
            btnBorder: '1.5px solid #3b82f6',
            btnColor: 'transparent',
            btnTextColor: '#3b82f6',
            btnShadow: 'none',
            btnRadius: '8px',
            btnHoverBg: '#3b82f6',
            btnHoverColor: '#ffffff',
            btnHoverBorder: '1.5px solid #3b82f6',
            detailBtnBg: 'transparent',
            detailBtnColor: '#64748b',
            detailBtnBorder: '1.5px solid #cbd5e1',
            detailBtnShadow: 'none'
        }
    },
    {
        id: 'soft-tinted',
        name: 'Soft Tinted Accent',
        desc: 'Gentle translucent accent background with refined border',
        settings: {
            btnBorder: '1px solid rgba(59,130,246,0.25)',
            btnColor: 'rgba(59,130,246,0.1)',
            btnTextColor: '#2563eb',
            btnShadow: 'none',
            btnRadius: '8px',
            btnHoverBg: '#2563eb',
            btnHoverColor: '#ffffff',
            btnHoverBorder: '1px solid #2563eb',
            detailBtnBg: '#f1f5f9',
            detailBtnColor: '#334155',
            detailBtnBorder: '1px solid #e2e8f0',
            detailBtnShadow: 'none'
        }
    },
    {
        id: 'luminous-pill',
        name: 'Luminous Pill Glow',
        desc: 'Full pill curvature with vibrant ambient halo glow',
        settings: {
            btnBorder: 'none',
            btnColor: '#3b82f6',
            btnTextColor: '#ffffff',
            btnShadow: '0 0 16px rgba(59,130,246,0.4)',
            btnRadius: '50px',
            btnHoverBg: '#1d4ed8',
            btnHoverColor: '#ffffff',
            btnHoverBorder: '',
            detailBtnBg: '#ffffff',
            detailBtnColor: '#334155',
            detailBtnBorder: '1px solid #e2e8f0',
            detailBtnShadow: '0 2px 8px rgba(0,0,0,0.06)'
        }
    },
    {
        id: 'brutalist-solid',
        name: 'Brutalist Offset',
        desc: 'Bold 2px black border with solid hard drop shadow',
        settings: {
            btnBorder: '2px solid #000000',
            btnColor: '#ffffff',
            btnTextColor: '#000000',
            btnShadow: '3px 3px 0px #000000',
            btnRadius: '0px',
            btnHoverBg: '#000000',
            btnHoverColor: '#ffffff',
            btnHoverBorder: '2px solid #000000',
            detailBtnBg: '#ffffff',
            detailBtnColor: '#000000',
            detailBtnBorder: '2px solid #000000',
            detailBtnShadow: '3px 3px 0px #000000'
        }
    },
    {
        id: 'monochrome-sleek',
        name: 'Monochrome Dark',
        desc: 'Deep slate primary with clean white bordered details button',
        settings: {
            btnBorder: 'none',
            btnColor: '#0f172a',
            btnTextColor: '#ffffff',
            btnShadow: '0 2px 8px rgba(15,23,42,0.15)',
            btnRadius: '8px',
            btnHoverBg: '#1e293b',
            btnHoverColor: '#ffffff',
            btnHoverBorder: '',
            detailBtnBg: '#ffffff',
            detailBtnColor: '#334155',
            detailBtnBorder: '1px solid #e2e8f0',
            detailBtnShadow: 'none'
        }
    }
];

export const IMAGE_PADDING_PRESETS = [
    { label: '0px (Flush)', value: '0px' },
    { label: '8px (Tight)', value: '8px' },
    { label: '12px (Balanced)', value: '12px' },
    { label: '16px (Matte)', value: '16px' },
    { label: '24px (Gallery)', value: '24px' }
];

export const CONTENT_PADDING_PRESETS = [
    { label: '8px (Tight)', value: '8px' },
    { label: '14px (Compact)', value: '14px' },
    { label: '20px (Standard)', value: '20px' },
    { label: '24px (Comfortable)', value: '24px' },
    { label: '32px (Spacious)', value: '32px' }
];

export const CAT_IMAGE_SIZE_PRESETS = [
    { label: '28px (Icon)', value: '28px' },
    { label: '48px (Small)', value: '48px' },
    { label: '64px (Medium)', value: '64px' },
    { label: '80px (Large)', value: '80px' },
    { label: '100px (Tile)', value: '100px' },
    { label: '120px (Card)', value: '120px' },
    { label: '160px (Hero)', value: '160px' }
];

export const CAT_IMAGE_RADIUS_PRESETS = [
    { label: 'Circle (50%)', value: '50%' },
    { label: 'Pill (20px)', value: '20px' },
    { label: 'Rounded (12px)', value: '12px' },
    { label: 'Card (8px)', value: '8px' },
    { label: 'Square (0px)', value: '0px' }
];

export const SHOP_THEME_PRESETS = [
    {
        id: 'tribal',
        name: '🦅 Tribal Spirit Gallery',
        desc: 'Earthy parchment, double borders, raw handcrafted aesthetic & warm amber buttons.',
        settings: {
            productCardBorder: '4px double #414141',
            productCardBorderRadius: '0px',
            productImageBorder: '5px solid #ffffff',
            productImageBorderRadius: '0px',
            shopCardBorder: '4px double #414141',
            shopCardBorderRadius: '0px',
            shopCardRadius: '0px',
            shopCardBg: '#f4efe6',
            shopImageBorder: '5px solid #ffffff',
            shopImageBorderRadius: '0px',
            shopImageObjectFit: 'cover',
            productCardShadow: 'none',
            pageBackground: '#fdfbf7',
            productPageBg: '#fdfbf7',
            productCardBg: '#f4efe6',
            btnColor: '#5c4033',
            btnRadius: '0px',
            detailBtnBg: '#f4efe6',
            detailBtnColor: '#5c4033',
            detailBtnBorder: '2px solid #5c4033',
            shopFilterPanelBg: '#f4efe6',
            shopFilterPanelBorder: '4px double #414141',
            shopFilterPanelRadius: '0px',
            shopFilterPanelShadow: 'none',
            shopFilterPanelDirection: 'row',
            shopCardDirection: 'row',
            shopCardImageWidth: '35%',
            shopCardImageHeight: 'auto',
            shopCatContainerBg: '#f4efe6',
            shopCatContainerBorder: 'none',
            shopCatContainerRadius: '0px',
            shopCatContainerPadding: '0px',
            shopCatContainerShadow: 'none',
            shopCatLabelColor: '#5c4033',
            shopCatLabelFontWeight: '700',
            shopCatLabelTransform: 'uppercase',
            shopCatBtnBg: '#e7e0d4',
            shopCatBtnColor: '#5c4033',
            shopCatBtnActiveBg: '#5c4033',
            shopCatBtnActiveColor: '#fdfbf7',
            shopCatBtnBorder: '2px solid #5c4033',
            shopCatBtnRadius: '0px',
            shopCatBtnPadding: '8px 16px',
            shopCatBtnTransform: 'uppercase',
            shopSubCatDivider: '2px solid #5c4033',
            shopSearchBg: '#fdfbf7',
            shopSearchColor: '#5c4033',
            shopSearchBorder: '2px solid #5c4033',
            shopSearchRadius: '0px',
            shopSearchPadding: '12px 20px',
            shopSearchFontSize: '1rem',
            shopSortBg: '#fdfbf7',
            shopSortColor: '#5c4033',
            shopSortBorder: '2px solid #5c4033',
            shopSortRadius: '0px',
            shopSortPadding: '12px 20px',
            shopSortLabelColor: '#5c4033',
            shopSortLabelFontWeight: '700',
            shopCategoryPathFontFamily: 'inherit',
            shopCategoryPathSize: '0.85rem',
            shopCategoryPathWeight: '600',
            shopCategoryPathColor: '#8c7b6d',
            shopCategoryPathActiveColor: '#5c4033',
            shopCategoryPathLinkColor: '#5c4033',
            shopCategoryPathTransform: 'uppercase',
            shopCategoryPathSeparator: '›'
        }
    },
    {
        id: 'modern',
        name: '✨ Modern Clean Store',
        desc: 'Minimalist white cards, crisp blue accents, contained media & subtle elevation.',
        settings: {
            pageBackground: '#f8fafc',
            primaryColor: '#2563eb',
            secondaryColor: '#0f172a',
            shopCardBg: '#ffffff',
            shopCardBorder: '1px solid #e2e8f0',
            shopCardBorderRadius: '14px',
            shopCardRadius: '14px',
            productCardShadow: '0 4px 12px -2px rgba(0,0,0,0.06)',
            shopImageObjectFit: 'contain',
            shopCardDirection: 'column',
            shopCardImageHeight: '230px',
            shopImageBorder: 'none',
            shopImageBorderRadius: '0px',
            btnColor: '#2563eb',
            btnTextColor: '#ffffff',
            btnRadius: '8px',
            btnPadding: '8px 16px',
            detailBtnBg: '#f1f5f9',
            detailBtnColor: '#334155',
            detailBtnBorder: '1px solid #cbd5e1',
            shopCatBtnBg: '#f1f5f9',
            shopCatBtnColor: '#475569',
            shopCatBtnActiveBg: '#2563eb',
            shopCatBtnActiveColor: '#ffffff',
            shopCatBtnRadius: '20px',
            shopFilterPanelBg: '#ffffff',
            shopFilterPanelBorder: '1px solid #e2e8f0',
            shopFilterPanelRadius: '12px',
            shopFilterPanelShadow: '0 2px 6px rgba(0,0,0,0.04)'
        }
    },
    {
        id: 'luxury',
        name: '🌙 Dark Luxury Catalog',
        desc: 'Deep navy background, luminous cyan accents, dark cards with prominent shadows.',
        settings: {
            pageBackground: '#0b1120',
            primaryColor: '#38bdf8',
            secondaryColor: '#0284c7',
            shopCardBg: '#1e293b',
            shopCardBorder: '1px solid #334155',
            shopCardBorderRadius: '12px',
            shopCardRadius: '12px',
            productCardShadow: '0 10px 25px -5px rgba(0,0,0,0.5)',
            shopImageObjectFit: 'cover',
            shopCardDirection: 'column',
            shopCardImageHeight: '220px',
            shopProductNameColor: '#f1f5f9',
            shopProductDescColor: '#94a3b8',
            shopProductPriceColor: '#38bdf8',
            shopProductCategoryColor: '#38bdf8',
            btnColor: '#38bdf8',
            btnTextColor: '#0b1120',
            btnRadius: '6px',
            detailBtnBg: '#334155',
            detailBtnColor: '#f1f5f9',
            detailBtnBorder: '1px solid #475569',
            shopCatBtnBg: '#1e293b',
            shopCatBtnColor: '#94a3b8',
            shopCatBtnActiveBg: '#38bdf8',
            shopCatBtnActiveColor: '#0b1120',
            shopCatBtnBorder: '1px solid #334155',
            shopFilterPanelBg: '#1e293b',
            shopFilterPanelBorder: '1px solid #334155',
            shopSearchBg: '#0f172a',
            shopSearchColor: '#f1f5f9',
            shopSearchBorder: '1px solid #334155',
            shopSortBg: '#0f172a',
            shopSortColor: '#f1f5f9',
            shopSortBorder: '1px solid #334155'
        }
    },
    {
        id: 'artisan',
        name: '🏺 Warm Artisan Boutique',
        desc: 'Rich terracotta hues, soft warm peach cards & bordered accents.',
        settings: {
            pageBackground: '#fffbf5',
            primaryColor: '#c2410c',
            secondaryColor: '#431407',
            shopCardBg: '#ffffff',
            shopCardBorder: '1px solid #fed7aa',
            shopCardBorderRadius: '10px',
            shopCardRadius: '10px',
            productCardShadow: '0 4px 10px rgba(194, 65, 12, 0.08)',
            shopImageObjectFit: 'contain',
            shopProductNameColor: '#431407',
            shopProductPriceColor: '#c2410c',
            shopProductCategoryColor: '#ea580c',
            btnColor: '#c2410c',
            btnTextColor: '#ffffff',
            btnRadius: '6px',
            detailBtnBg: '#fff7ed',
            detailBtnColor: '#9a3412',
            detailBtnBorder: '1px solid #fed7aa',
            shopCatBtnBg: '#ffedd5',
            shopCatBtnColor: '#9a3412',
            shopCatBtnActiveBg: '#c2410c',
            shopCatBtnActiveColor: '#ffffff',
            shopFilterPanelBg: '#fff7ed',
            shopFilterPanelBorder: '1px solid #fed7aa'
        }
    },
    {
        id: 'cyber',
        name: '⚡ Cyber Neon Glass',
        desc: 'Glowing translucent cards with dark cyber ambiance & cyan highlights.',
        settings: {
            pageBackground: '#090d16',
            primaryColor: '#06b6d4',
            secondaryColor: '#8b5cf6',
            shopCardBg: 'rgba(15, 23, 42, 0.85)',
            shopCardBorder: '1px solid rgba(6, 182, 212, 0.35)',
            shopCardBorderRadius: '14px',
            shopCardRadius: '14px',
            productCardShadow: '0 0 20px rgba(6, 182, 212, 0.15)',
            shopImageObjectFit: 'cover',
            shopProductNameColor: '#e0f2fe',
            shopProductPriceColor: '#22d3ee',
            shopProductCategoryColor: '#a855f7',
            btnColor: '#06b6d4',
            btnTextColor: '#090d16',
            btnRadius: '8px',
            detailBtnBg: 'rgba(30, 41, 59, 0.8)',
            detailBtnColor: '#22d3ee',
            detailBtnBorder: '1px solid rgba(6, 182, 212, 0.3)',
            shopCatBtnBg: 'rgba(30, 41, 59, 0.7)',
            shopCatBtnColor: '#94a3b8',
            shopCatBtnActiveBg: '#06b6d4',
            shopCatBtnActiveColor: '#090d16',
            shopFilterPanelBg: 'rgba(15, 23, 42, 0.85)',
            shopFilterPanelBorder: '1px solid rgba(6, 182, 212, 0.3)'
        }
    }
];
